class Faq {
  constructor() {
    this.init();
  }

  init() {
    const faqs = document.querySelectorAll('.faq__wrapper-question');

    faqs.forEach(question => {
      const answer = question.nextElementSibling;
      const plusIcon = question.querySelector('.plus');
      const minusIcon = question.querySelector('.minus');

      question.addEventListener('click', () => {
        // zatvori sve ostale
        faqs.forEach(q => {
          if (q !== question) {
            q.classList.remove('active');
            q.nextElementSibling.style.maxHeight = null;
            q.querySelector('.plus').classList.remove('d-none');
            q.querySelector('.minus').classList.add('d-none');
          }
        });

        // toggle trenutno
        question.classList.toggle('active');
        if (question.classList.contains('active')) {
          answer.style.maxHeight = answer.scrollHeight + "px";
          plusIcon.classList.add('d-none');
          minusIcon.classList.remove('d-none');
        } else {
          answer.style.maxHeight = null;
          plusIcon.classList.remove('d-none');
          minusIcon.classList.add('d-none');
        }
      });
    });
  }
}

export default Faq;
